module.exports = __webpack_public_path__ + "static/fd4017ba-ecf9-41e1-b4e0-28284e1ab950-26a006b73ae1b191b5199be8dad8a7ca.jpg";